import { render, staticRenderFns } from "./NotificationTileRequestAuthor.vue?vue&type=template&id=e4730d42&scoped=true&"
import script from "./NotificationTileRequestAuthor.vue?vue&type=script&lang=js&"
export * from "./NotificationTileRequestAuthor.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTileRequestAuthor.vue?vue&type=style&index=0&id=e4730d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4730d42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VAvatar,VIcon,VRating})
